import { useEffect } from 'react';
import type { ILocalAudioTrack, ILocalVideoTrack } from 'agora-rtc-sdk-ng';

export default function useRestartAudioTrackOnDeviceChange(
  localTracks: (ILocalAudioTrack | ILocalVideoTrack)[]
) {
  const audioTrack = localTracks.find(t => t.trackMediaType === 'audio') as ILocalAudioTrack | undefined;

  useEffect(() => {
    const handleDeviceChange = () => {
      const mt = audioTrack?.getMediaStreamTrack?.();
      if (mt?.readyState === 'ended') {
        // Agora: no restart(); user may need to rejoin or re-acquire tracks. Optional: close and trigger re-acquire.
      }
    };
    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
    return () => navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
  }, [audioTrack]);
}
